// src/components/Home.js
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HomeBanner from './HomeBanner';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    
    // Only redirect if user is logged in, otherwise show home page
    if (token && role === 'admin') {
      navigate('/admin');
    } else if (token && role === 'dispatch') {
      navigate('/dashboard/dispatch');
    } else if (token && role === 'professional') {
      navigate('/dashboard/accepted-jobs');
    } else if (token && role === 'listing_only') {
      navigate('/dashboard');
    }
    // If no token, stay on home page - menu button is in Navigation component
  }, [navigate]);

  return (
    <div className="container mt-3">

      {/* Hero Section */}
      <div className="text-center pt-3 pb-3 mb-4">
        <div className="mb-2">
          <img src="/logo192.png" alt="Taxi-Local.uk" style={{ maxWidth: '150px' }} />
        </div>
        <h1 className="fw-bold mb-2">Taxi-Local.uk</h1>
        <p className="lead mb-0">Linking local taxis and clients in real-time</p>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-5">
        <Link to="/fare-calculator" className="btn btn-success btn-lg">
          Book Taxi Online
        </Link>
      </div>

      {/* Info Cards */}
      <div className="px-3">
        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h2 className="mb-0">Taxi-Local.UK: A Smarter Way to Book Rural Taxis in Britain</h2>
  </div>
  <div className="card-body text-center">
    <p>
      Getting a taxi in rural Britain has long been a frustrating task—especially when time is tight.
      Too often, passengers call through lists of firms only to hear: "Sorry, we're fully booked."
      That's where Taxi-Local.UK steps in—revolutionising how rural journeys are booked by connecting
      customers with a network of independent local taxi operators, all in one go.
    </p>
  </div>
</div>


        <div className="card mb-4"> 
  <div className="card-header bg-warning text-center">
    <h4 className="mb-0">Connecting Rural Britain, One Booking at a Time</h4>
  </div>
  <div className="card-body text-center">
    <p>
      Taxi-Local.UK isn't just another taxi app. It's a smart dispatching platform for rural and semi-rural
      communities. Submit your journey request, and it goes to a cluster of local firms in real time. No response?
      No problem. You'll get a list of all contacted firms and their phone numbers—transparent, simple, and fast.
    </p>
  </div>
</div>


        <div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h5 className="mb-0">How It Works:</h5>
  </div>
  <div className="card-body text-center">
    <p> Enter your journey details: where, when, and how many passengers.</p>
    <p> We notify a cluster of local, independent taxi firms.</p>
    <p> If one accepts, you're instantly connected.</p>
    <p> If no one accepts, you receive contact details of every firm notified.</p>
    <p> Choose ASAP or a future booking—flexibility built in.</p>
  </div>
</div>

<div className="card mb-4">
  <div className="card-header bg-warning text-center">
    <h5 className="mb-0">Why Taxi-Local.UK?</h5>
  </div>
  <div className="card-body text-center">
    <p>✅ <strong>Time-Saving</strong>: One request reaches many firms at once.</p>
    <p>✅ <strong>Transparent</strong>: See who's been contacted, even if unavailable.</p>
    <p>✅ <strong>Local First</strong>: Supports independent taxi firms, not big corporations.</p>
    <p>✅ <strong>Responsive</strong>: Real-time job offers to local operators.</p>
    <p>✅ <strong>Smart Booking</strong>: Return trips, passenger counts, future planning.</p>
  </div>
</div>


        <div className="card mb-4">
          <div className="card-header bg-warning text-center">
            <h5 className="mb-0">Supporting Local Taxi Businesses</h5>
          </div>
          <div className="card-body text-center">
            <p>
              Taxi-Local.UK is an ally—not a competitor—for small taxi firms. Drivers stay in control of pricing,
              availability, and job acceptance while getting more leads from their area.
            </p>
            <p>
              In places with driver shortages and rising fuel costs, this platform supports continuity—especially
              for parents, seniors, and those without vehicles.
            </p>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-header bg-warning text-center">
            <h5 className="mb-0">Coming Soon to More Areas</h5>
          </div>
          <div className="card-body text-center">
            <p>
              Now launching in East Devon, Warwickshire, and across the South West, Taxi-Local.UK is growing fast.
              As more firms join, the system becomes even smarter and more effective.
            </p>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-header bg-warning text-center">
            <h4 className="mb-0">Tired of hearing "No taxis available"?</h4>
          </div>
          <div className="card-body text-center">
            <p>Let Taxi-Local.UK do the calling for you.</p>
            <div className="text-center mt-3">
              <Link to="/fare-calculator" className="btn btn-success btn-lg">
                Book Taxi Online
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Banner at bottom of page */}
      <HomeBanner />
    </div>
  );
};

export default Home;
